import { SelectPickerOptionProps } from '@cp/src/components/interfaces';

export const convertObjectToDropdownOptions = (
  data: Record<string, string>
): SelectPickerOptionProps[] => {
  if (!data || typeof data !== 'object') return [];
  return Object.entries(data).map(([key, value]) => ({
    label: value,
    value: key
  })) as SelectPickerOptionProps[];
};

export const getDecodedUrlParam = (param: string | null): string | null => {
  return param ? decodeURIComponent(param) : null;
};

export const findOptionByValue = (
  options: SelectPickerOptionProps[],
  value: string | null
): SelectPickerOptionProps | undefined => {
  if (!value || !options.length) return undefined;
  return options.find(option => option.value === value);
};
